import { DefaultButton, PrimaryButton, TextField } from "@fluentui/react";
import React, { useState,useEffect,useContext } from "react";
import NextPreviousSection from "../NextPreviousSection.jsx/NextPreviousSection";
import ContactDetailsRow from "./ContactDetialsRow";
import { t } from "i18next";
import { ACTIONS, USERTYPES } from "../../../../constants/Constants";
import { Checkbox } from "@fluentui/react";
import CustomTextField from "../../../Hospital/components/ContactDetails/CustomTextField";
import CustomPhoneInput from "../../../Hospital/components/ContactDetails/CustomPhoneInput";
import { proxyPropertyState } from "@kitware/vtk.js/macros";
import { checkWhatsAppEnabled2} from '../../../../service/StudyListService';
import themeContext from "../../../../context/theme/ThemeContext";
import { getEnv } from '../../../../helpers/EnvHelper';

const ContactDetailsSection = (props) => {
    let isEnableWhatsApp =   (getEnv("REACT_APP_ENABLE_WHATSAPP") == "true" || getEnv("REACT_APP_ENABLE_WHATSAPP") == true) ? true : false;

  console.log("Props inside constaceDeatailsSection: ",props);
   const {
    values,
    handleBlur,
    handleChange,
    setFieldValue,
    action,
    roles,errors, touched,setErrorContactState,
  } = props;
    
  const { themeName, getThemeColor } = useContext(themeContext);

  const creatingByFirmAdminOnAdd = (action === ACTIONS.ADD || action === ACTIONS.EDIT) && props.roles[0] === USERTYPES.FIRMADMIN;
  const creatingByFirmAdminOnAdd2 = (action === ACTIONS.ADD || action === ACTIONS.EDIT) && (props.roles[0] === USERTYPES.FIRMADMIN || props.roles[0] === USERTYPES.ADMIN);

  const isSuperAdmin = props.roles[0] === USERTYPES.ADMIN;
  console.log("IS SUPER ADMIN ", isSuperAdmin);
  //fetched flags from the backend
  const [masterOn, setMasterOn] = useState(false);       // allowFirmAdminSetClientComm
  const [canEmail, setCanEmail] = useState(false);       // firmAdminCanEnableEmail
  const [canWhatsapp, setCanWhatsapp] = useState(false); // firmAdminCanEnableWhatsapp
  // guard so fetch only sets initial enable flags once
  const [flagsLoaded, setFlagsLoaded] = useState(false);
  // // Local state for checkboxes
  const [showEmailInput, setShowEmailInput] = useState(!!values.firmEmailNotify ); 
  const [showWhatsAppInput, setShowWhatsAppInput] = useState(!!values.firmWhatsappNotify);

  const [enableEmail, setEnableEmail] = useState(!!values.enableEmail);
  const [enableWhatsApp, setEnableWhatsApp] = useState(!!values.enableWhatsApp);


  // Some derived helpers
  const isFirmAdmin = Array.isArray(roles) && roles.includes(USERTYPES.FIRMADMIN);
  const isEdit = action === "EDIT";
  const isOwnFirm = !!props.ownFirm;
  const disableParentAccessToggle = isFirmAdmin && isEdit && isOwnFirm;
  const isView = action === ACTIONS.VIEW;


  // Global WhatsApp kill-switch
  useEffect(() => {
  if (!isEnableWhatsApp) {
    console.log("[GlobalFlag] WhatsApp disabled globally → force clearing state");

    // local UI state
    setShowWhatsAppInput(false);
    setEnableWhatsApp(false);
    if(isFirmAdmin && isEdit){
      setShowEmailInput(true);
    }

    // Formik state
    setFieldValue("enableWhatsApp", false, false);
    setFieldValue("whatsappNumber", "", false);

    // clear any WhatsApp errors
  if (typeof props.setErrorContactState === "function") {
      props.setErrorContactState(prev => ({
        ...prev,
        contactChannel: {
          ...(prev.contactChannel || {}),
          whatsappNumber: { error: false, msg: "" }
        }
      }));
    }
    if (props.setFieldError) {
      props.setFieldError("whatsappNumber", undefined);
      props.setFieldError("enableWhatsApp", undefined);
    }
  }
}, []);


   // Mark minimal account when ADD by firm admin
  useEffect(() => {
    if (action === ACTIONS.ADD && creatingByFirmAdminOnAdd) {
      setFieldValue("isMinimalAccount", 1, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Sync local checkbox states with Formik values
  // useEffect(() => {
  //   setEnableEmail(!!values.enableEmail);
  //   setEnableWhatsApp(!!values.enableWhatsApp);
  // }, [values.enableEmail, values.enableWhatsApp]);

  useEffect(() => {
    // logs to help debugging
    console.log("[ContactDetails] Sync from Formik -> local:", {
      valuesEnableEmail: values.enableEmail,
      valuesEnableWhatsApp: values.enableWhatsApp
    });

    setEnableEmail(!!values.enableEmail);
    setEnableWhatsApp(!!values.enableWhatsApp);
  }, [values.enableEmail, values.enableWhatsApp]);

  // fetch flags when creating new hospital/client by firm-admin
  useEffect(() => {
//     if (!isEnableWhatsApp) {
//   console.log("[GlobalFlag] Skipping checkWhatsAppEnabled2 API");
//   setCanWhatsapp(false);
//   return;
// }

  // Only fetch when a firm-admin is creating a new hospital
  if (!creatingByFirmAdminOnAdd) return;

  let cancelled = false;
  (async () => {
    try {
      // If your service expects a firmId param, pass undefined or {}
      // but since controller now falls back to logged-in user's frmId, send empty GenericDto
      //const resp = await checkWhatsAppEnabled2({ data: {} });
      const resp = await checkWhatsAppEnabled2({
        data: {
          firmId: values.id,
          isMinimalAccount: values.isMinimalAccount
        }
      });

      if (cancelled) return;
      if (!resp || resp.status !== 200) {
        console.warn("checkWhatsAppEnabled2: unexpected response", resp);
        return;
      }

      const wrapper = resp.data;
      if (wrapper?.result !== "SUCCESS") {
        console.warn("checkWhatsAppEnabled2: backend returned failure", wrapper);
        return;
      }

      const data = wrapper.data || {};

      // update backend flag states
      const backendMaster = !!data.allowFirmAdminSetClientComm;
      const backendCanEmail = !!data.firmAdminCanEnableEmail;
      const backendCanWhatsapp = !!data.firmAdminCanEnableWhatsapp;

      console.log("[ContactDetails] backend flags:", { backendMaster, backendCanEmail, backendCanWhatsapp, data });

      //  Update flag states directly from API data
      setMasterOn(backendMaster);
      setCanEmail(backendCanEmail);
      setCanWhatsapp(backendCanWhatsapp);

      // set form-level flags (optional, keeps form state consistent)
      setFieldValue("allowFirmAdminSetClientComm", backendMaster, false);
      setFieldValue("firmAdminCanEnableWhatsapp", backendCanWhatsapp, false);
      setFieldValue("firmAdminCanEnableEmail", backendCanEmail, false);
      
      // derive forced cases and set enable flags accordingly so checkbox shows checked when forced
      
      if (!flagsLoaded) {
      //const onlyEmailEnabled = (!backendMaster) || (backendMaster && backendCanEmail && !backendCanWhatsapp);
      const onlyEmailEnabled =  ( backendCanEmail && !backendCanWhatsapp);
      const onlyWhatsappEnabled = (backendMaster && backendCanWhatsapp && !backendCanEmail);
      if (onlyEmailEnabled) {
          console.log("[ContactDetails] forcing onlyEmailEnabled initial state");
          //setFieldValue("enableEmail", true, false);
          setFieldValue("enableEmail", !!values.enableEmail, false);
          setEnableEmail(true);
          setFieldValue("enableWhatsApp", false, false);
          setEnableWhatsApp(false);
        } else if (onlyWhatsappEnabled) {
          console.log("[ContactDetails] forcing onlyWhatsappEnabled initial state");
          setFieldValue("enableWhatsApp", true, false);
          setEnableWhatsApp(true);
          setFieldValue("enableEmail", false, false);
          setEnableEmail(false);
        } else if (props.action === ACTIONS.ADD && backendMaster && backendCanEmail && backendCanWhatsapp) {
            // NEW BLOCK: Default when both channels are allowed during ADD action
            console.log("[ContactDetails] all three flags true -> setting email default. Checking WhatsApp state.");
            
            // 1. Always set Email to true as it's the required default in this case
              setFieldValue("enableEmail", true, false);
              setEnableEmail(true);

            // 2. ONLY set WhatsApp to false if the Formik value is NOT already true (i.e., user hasn't checked it).
            if (!values.enableWhatsApp) { 
                console.log("[ContactDetails] setting default enableWhatsApp = false.");
                setFieldValue("enableWhatsApp", false, false);
                setEnableWhatsApp(false);
            } else {
                console.log("[ContactDetails] preserving user-selected enableWhatsApp = true.");
                // If it's already true, we do nothing and rely on the sync useEffect to keep the local state updated.
            }

 }else {
          // if backend provided defaults for enable flags, apply them (non-forced scenario)
          // if (typeof data.emailEnabled !== "undefined") {
          //   setFieldValue("enableEmail", !!data.emailEnabled, false);
          //   setEnableEmail(!!data.emailEnabled);
          // }
          // if (typeof data.whatsappEnabled !== "undefined") {
          //   setFieldValue("enableWhatsApp", !!data.whatsappEnabled, false);
          //   setEnableWhatsApp(!!data.whatsappEnabled);
          // }
         console.log("[ContactDetails] applied backend defaults for enable flags");
        }
        setFlagsLoaded(true);
        } else {
          console.log("[ContactDetails] flagsLoaded true — not overwriting user toggles");
        }
      // clear channel-level errors (prevents stale error messages)
      clearContactChannelErrors();
    } catch (err) {
      console.error("Error fetching firm flags", err);
    }
  })();

  return () => {
    cancelled = true;
  };
  // run once when component mounts for add-by-firm-admin
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [creatingByFirmAdminOnAdd]);


  // clear channel-level errors (reset to initial shape)
const clearContactChannelErrors = () => {
  if (typeof props.setErrorContactState === "function") {
    props.setErrorContactState((prev) => {
      const copy = { ...prev };
      copy.contactChannel = {
        error: false,
        msg: "",
        notificationEmail: { error: false, msg: "" },
        whatsappNumber: { error: false, msg: "" }
      };
      return copy;
    });
  }
  // also clear any Formik-level error attached to enableEmail (optional)
  if (props.setFieldError) {
    props.setFieldError("enableEmail", undefined);
    props.setFieldError("whatsappNumber", undefined);
    props.setFieldError("notificationEmail", undefined);
  }
};

  // Determine full firm vs minimal client
  const creatingByFirmAdmin = creatingByFirmAdminOnAdd; // alias
  const isMinimal = (values?.isMinimalAccount === 1 || values?.isMinimalAccount === undefined) && creatingByFirmAdmin;
    console.log("CONTACTDETAILSSECTION values?.isMinimalAccount", values?.isMinimalAccount);
    console.log("CONTACTDETAILSSECTION creatingByFirmAdmin", creatingByFirmAdmin);


  console.log("CONTACTDETAILSSECTION: ISMINIMAL", isMinimal);
  const isFullFirm = !isMinimal;

  // Derived UI decisions based on backend flags
  // onlyEmailEnabled: master OFF (email mandatory) OR master ON but only email allowed
  const onlyEmailEnabled = (!masterOn) || (masterOn && canEmail && !canWhatsapp);
  const onlyWhatsappEnabled = (masterOn && canWhatsapp && !canEmail);

  // visibility decisions
  const showEmailCheckbox = masterOn ? canEmail : true;     // if master is off we still show email (it's mandatory)
  const showWhatsappCheckbox = masterOn ? canWhatsapp : false;

  // forced/disabled states (checkbox must be checked and disabled)
  const emailForced = onlyEmailEnabled;
  const whatsappForced = onlyWhatsappEnabled;

  // Automatically enforce correct default behavior for minimal clients
  // useEffect(() => {
  //   if (isMinimal && !masterOn) {
  //     // master OFF => Email mandatory, WhatsApp disabled
  //     setFieldValue("enableEmail", true, false);
  //     setFieldValue("enableWhatsApp", false, false);
  //     setEnableEmail(true);
  //     setEnableWhatsApp(false);
  //   } else if (isMinimal && masterOn) {
  //     // master ON => follow subflags
  //     if (!canEmail) {
  //       setFieldValue("enableEmail", false, false);
  //       setEnableEmail(false);
  //     }
  //     if (!canWhatsapp) {
  //       setFieldValue("enableWhatsApp", false, false);
  //       setEnableWhatsApp(false);
  //     }
  //   }
  // }, [isMinimal, masterOn, canEmail, canWhatsapp]);  
  useEffect(() => {
    console.log("[ContactDetails] values.enableEmail changed:", values.enableEmail);
  }, [values.enableEmail]);

  useEffect(() => {
    console.log("[ContactDetails] values.enableWhatsApp changed:", values.enableWhatsApp);
  }, [values.enableWhatsApp]);

  // add right after your other debug effect
  useEffect(() => {
    console.log("[TRACE] values.enableEmail changed ->", values.enableEmail, " (flagsLoaded:", flagsLoaded, ")");
    // show call stack so you can see what lead to this render (helpful)
    console.trace();
  }, [values.enableEmail]);

  useEffect(() => {
    console.log("[TRACE] values.enableWhatsApp changed ->", values.enableWhatsApp, " (flagsLoaded:", flagsLoaded, ")");
    console.trace();
  }, [values.enableWhatsApp]);

// // Debug render-time log
//   console.log("[ContactDetails] render state:", {
//     masterOn, canEmail, canWhatsapp, emailForced, whatsappForced,
//     enableEmail, enableWhatsApp, formikEnableEmail: values.enableEmail, formikEnableWhatsApp: values.enableWhatsApp
//   });
  // ensure this runs once when backend flags are loaded so we don't overwrite user toggles later
  // useEffect(() => {
  //   // when master and both subflags are true => default only email checked
  //   if (props.action === ACTIONS.ADD && masterOn && canEmail && canWhatsapp) {
  //     console.log("[ContactDetails] all three flags true -> default: enableEmail = true, enableWhatsApp = false");
  //     // set local UI state immediately
  //     setEnableEmail(true);
  //     setEnableWhatsApp(false);
  //     // persist to Formik so values.enableEmail reflects it
  //     setFieldValue && setFieldValue("enableEmail", true);
  //     setFieldValue && setFieldValue("enableWhatsApp", false);
  //   }
  // }, [masterOn, canEmail, canWhatsapp, setFieldValue]);

    return (
        <>
        <div className="tab-section">
          <section className="sectionA">
            <p
              style={{
                fontSize: "22px",
                fontWeight: "600",
                marginBottom: "20px",
              }}
            >
              {t("hospital.contact-details")}
            </p>
          </section>
           {/* ── WhatsApp toggle + number (above First Contact Details) ── */}
          {/* WhatsApp in Contact Details header area */}
          {/* <div className="ms-Grid" dir="ltr" style={{marginBottom:"-12px"}}>
            {isView ? (
                <>
              <div className="ms-Grid-row" style={{ alignItems: "center", marginBottom: 12 }}> */}
              {/* Enable Email (view) */}
              {/* <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl3">
                <div className="form-heading">Enable Email</div>
                <div className="form-mt-10">{values.enableEmail ? "Yes" : "No"}</div>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                <div className="form-heading">Notification Email</div>
                <div className="form-mt-10">
                  {values.enableEmail ? (values.notificationEmail || "-") : "-"}

                </div>
              </div>
              </div> */}
              {/* //  READ-ONLY ROWS (text only) */}
              {/* <div className="ms-Grid-row" style={{ alignItems: "center", marginBottom: 12 }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl3">
                  <div className="form-heading">Enable WhatsApp</div>
                  <div className="form-mt-10">{values.enableWhatsApp ? "Yes" : "No"}</div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                  <div className="form-heading">WhatsApp Number</div>
                  <div className="form-mt-10">
                    {values.enableWhatsApp ? (values.whatsappNumber || "-") : "-"}
                  </div>
                </div>
              </div>
              </>  */}
            <div className="ms-Grid" dir="ltr" style={{marginBottom:"-12px"}}>
    {isView ? (
        <>
        {/* ======================================================= */}
        {/* CASE 1: FULL FIRM (!isMinimal) - Shows both channels as saved */}
        {/* ======================================================= */}
        {!(values?.isMinimalAccount === 1) && (
            <>
            {/* Full Firm Email Row */}
            {/* {values.enableEmail && (
            <div className="ms-Grid-row" style={{ alignItems: "center", marginBottom: 12 }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl4">
                    <div className="form-heading">Email enabled for Firm Users</div>
                    <div className="form-mt-10">{values.enableEmail ? "Yes" : "No"}</div>
                    <div className="form-mt-10">
                        {values.enableEmail ? (values.notificationEmail || "-") : "-"}
                    </div>
                </div>
            </div>
            )} */}
            {/* {values.enableEmail && ( */}
              <div className="ms-Grid-row" style={{ alignItems: "center", marginBottom: 12 }}>
                  {/* Row for the Email Enabled Label and Yes/No */}
                  <div className="ms-Grid-row" style={{ alignItems: "center", marginLeft: 0 }}>
                      {/* Column for the Label (Left) - Takes 8/12 units on mobile, 4/12 on medium/large screens */}
                      <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl4">
                          <div className="form-heading">Email enabled for Firm Users</div>
                      </div>
                      {/* Column for the Value (Right) - Takes 4/12 units on mobile, 2/12 on medium/large screens */}
                      <div className="ms-Grid-col ms-sm4 ms-md2 ms-lg1">
                        <div className="form-mt-10" style={{ textAlign: "right" }}>
                            {values.enableEmail ? "Yes" : "No"}</div>
                      </div>
                  </div>

                  <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl4">
                      <div className="form-mt-10">
                          {values.notificationEmail ? (values.notificationEmail || "-") : "-"}
                      </div>
                  </div>
              </div>
          {/* )} */}
            {/* Full Firm WhatsApp Row */}
            {/* {values.enableWhatsApp && (
            <div className="ms-Grid-row" style={{ alignItems: "center", marginBottom: 12 }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl4">
                    <div className="form-heading">WhatsApp enabled for Firm Users</div>
                    <div className="form-mt-10">{values.enableEmail ? "Yes" : "No"}</div>
                    <div className="form-mt-10">
                        {values.enableWhatsApp ? (values.whatsappNumber || "-") : "-"}
                    </div>
                </div>
            </div>
            )} */}
            {/* {values.enableWhatsApp && ( */}
              {isEnableWhatsApp && (
            <div className="ms-Grid-row" style={{ alignItems: "center", marginBottom: 12 }}>
                
                {/* Row for the WhatsApp Enabled Label and Yes/No (The side-by-side line) */}
                <div className="ms-Grid-row" style={{ alignItems: "center", marginLeft: 0 }}>
                    
                    {/* Column for the Label (Left) - Takes up 8 units */}
                    <div className="ms-Grid-col ms-sm8 ms-md4 ms-lg3 ms-xl4">
                        <div className="form-heading">WhatsApp enabled for Firm Users</div>
                    </div>
                    
                    {/* Column for the Value (Right) - Takes up 4 units */}
                    <div className="ms-Grid-col ms-sm4 ms-md2 ms-lg1">
                        <div className="form-mt-10" style={{ textAlign: "right" }}>
                            {values.enableWhatsApp ? "Yes" : "No"}
                        </div>
                    </div>
                    
                </div>

                <div className="ms-Grid-row"  style={{ marginLeft: 0 }}> 
                    <div className="ms-Grid-col ms-sm8 ms-md4 ms-lg3 ms-xl4">
                        <div className="form-mt-10">
                            {values.whatsappNumber ? (values.whatsappNumber || "-") : "-"}
                        </div>
                    </div>
                </div>
                
            </div>
              )}
        {/* )} */}
            </>
        )}
        {values?.isMinimalAccount === 1 && (
            <>
            {/* Full Firm Email Row */}
            {values.enableEmail && (
            <div className="ms-Grid-row" style={{ alignItems: "center", marginBottom: 12 }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl4">
                    <div className="form-heading">Email</div>
                    {/* <div className="form-mt-10">{values.enableEmail ? "Yes" : "No"}</div> */}
                    <div className="form-mt-10">
                        {values.enableEmail ? (values.notificationEmail || "-") : "-"}
                    </div>
                </div>
            </div>
            )}
            
            {/* Full Firm WhatsApp Row */}
            {values.enableWhatsApp && isEnableWhatsApp && (
            <div className="ms-Grid-row" style={{ alignItems: "center", marginBottom: 12 }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl4">
                    <div className="form-heading">WhatsApp</div>
                    {/* <div className="form-mt-10">{values.enableEmail ? "Yes" : "No"}</div> */}
                    <div className="form-mt-10">
                        {values.enableWhatsApp ? (values.whatsappNumber || "-") : "-"}
                    </div>
                </div>
            </div>
            )}
            
            </>
        )}

        {/* ======================================================= */}
        {/* CASE 2: MINIMAL CLIENT, MASTER OFF (!masterOn) - Only Email mandatory */}
        {/* ======================================================= */}
        {isMinimal && !masterOn && (
            <>
            {/* Minimal/Master OFF Email Row (Mandatory *) */}
            <div className="ms-Grid-row" style={{ alignItems: "center", marginBottom: 12 }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl3">
                    {/* Email is mandatory here, so we display the asterisk */}
                    <div className="form-heading">Email </div>
                    {/* We display the value directly, as it must be set */}
                    <div className="form-mt-10">
                        {values.notificationEmail || "-"}
                    </div>
                </div>
            </div>
            {/* WhatsApp is explicitly hidden in this scenario */}
            </>
        )}

        {/* ======================================================= */}
        {/* CASE 3: MINIMAL CLIENT, MASTER ON (masterOn) - Conditional on canEmail/canWhatsapp */}
        {/* ======================================================= */}
        {isMinimal && masterOn && (
            <>
            {/* Minimal/Master ON Email Row (Conditional on canEmail) */}
            {canEmail && values.enableEmail && (
                <div className="ms-Grid-row" style={{ alignItems: "center", marginBottom: 12 }}>
                    <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl3">
                        <div className="form-heading">Email</div>
                        <div className="form-mt-10">
                            {values.notificationEmail ? (values.notificationEmail || "-") : "-"}
                        </div>
                    </div>
                </div>
            )}
            
            {/* Minimal/Master ON WhatsApp Row (Conditional on canWhatsapp) */}
            {canWhatsapp && values.enableWhatsApp && isEnableWhatsApp && (
                <div className="ms-Grid-row" style={{ alignItems: "center", marginBottom: 12 }}>
                    <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl3">
                        <div className="form-heading">WhatsApp</div>
                        <div className="form-mt-10">
                            {values.whatsappNumber ? (values.whatsappNumber || "-") : "-"}
                        </div>
                    </div>
                </div>
            )}
            </>
        )}
        </>
            ) : (
              <>
              {/* -------- Full Firm Creation  ----- */}
              {!(values?.isMinimalAccount === 1) && (action === ACTIONS.ADD || action === ACTIONS.EDIT) && (props.roles[0] === USERTYPES.ADMIN || props.roles[0] === USERTYPES.FIRMADMIN) && (
              <>
                <>
              <div className="ms-Grid-row" style={{ alignItems: "center", marginBottom: 12 }}>             
                {/* Enable Email (edit) */}
                {/* Top checkbox: ONLY controls visibility via showEmailInput */}
                <div className="form-field ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl3">
                <Checkbox
                    label={<span style={{ color: themeName === "light"? "black":"white", fontWeight: 600, fontSize: 14 }}>Enable Email</span>}
                   //checked={!!values.enableEmail}
                   checked={!!showEmailInput}
                   disabled={disableParentAccessToggle}
                  //checked={emailForced ? true : enableEmail}
                  //checked={ (isSuperAdmin ? !!values.enableEmail : (emailForced ? true : !!values.enableEmail)) }
                  //disabled={emailForced || disableParentAccessToggle}
                  //disabled={ (isSuperAdmin ? false : (emailForced || disableParentAccessToggle)) }
                  onChange={(_, checked) => {
                    const isChecked = !!checked;
                    //console.log("[ContactDetails] Email checkbox clicked. checked:", checked);
                    //setShowEmailInput(!!checked);
                    setShowEmailInput(isChecked);
                    setFieldValue("firmEmailNotify",isChecked);
                    //setFieldValue("enableEmail", !!checked);
                    if (!checked) setFieldValue("notificationEmail", "");
                    const nextValues = { ...values, firmEmailNotify:isChecked, enableEmail: !!checked, notificationEmail: !!checked ? values.notificationEmail : "" };
                    //setEnableEmail(!!checked);

                    // clear channel-level UI immediately (prevents flicker)
                    if (typeof props.setErrorContactState === "function") {
                      props.setErrorContactState(prev => ({
                        ...prev,
                        contactChannel: { error:false, msg:"", notificationEmail:{error:false,msg:""}, whatsappNumber:{error:false,msg:""} }
                      }));
                    }
                    if (props.setFieldError) props.setFieldError("notificationEmail", undefined);
                            console.log("[ContactDetails] setFieldValue enableEmail ->", !!checked);
                    // call the validator with the prospective values
                    if (props.validateChannels) props.validateChannels(nextValues);
                    else if (props.validateForm) props.validateForm();
                    
                  }}
                />
              </div>
            {/* {!!values.enableEmail && ( */}
              {!!showEmailInput && (
              <>
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">                
                <TextField
                //className="form-field ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4"
                //label="Notification Email"
                name="notificationEmail"
                value={values.notificationEmail || ""}
                //onChange={handleChange}
                onChange={(e) => {
                  const newEmail = e.target.value;
                  handleChange(e);
if (typeof setErrorContactState === "function") {
                   setErrorContactState(prev => ({
                    ...prev,
                    contactChannel: { ...(prev.contactChannel||{}), whatsappNumber:{ error:false, msg:"" }, error:false, msg:"" }
                   }));
                  }
                  if (props.setFieldError) props.setFieldError("notificationEmail", undefined);
                  const nextValues = { ...values, notificationEmail: newEmail };
                  if (props.validateChannels) props.validateChannels(nextValues);
                }}

                //onBlur={handleBlur}
                // errorMessage={
                //   touched?.notificationEmail && errors?.notificationEmail
                //     ? errors.notificationEmail
                //     : props.errorContactState?.contactChannel?.notificationEmail?.msg || undefined
                // }
                onBlur={(e) => {
                  handleBlur(e);
                  if (props.validateChannels) {
                    const nextValues = { ...values, notificationEmail: values.notificationEmail };
                    props.validateChannels(nextValues);
                  }
                }}
                errorMessage={
                  // prefer channel-level message if present
                  //(props.errorContactState?.contactChannel?.notificationEmail?.msg) ||
                 // (touched?.notificationEmail && errors?.notificationEmail) ||
                  undefined
                }
              />
              <div style={{ width: "100%", marginTop: 6, marginBottom: 6 }}>
                <div style={{ color: "red", fontSize: 12, fontWeight: "600"  }}>
                  {props.errorContactState?.contactChannel?.notificationEmail?.msg ||
                  (touched?.notificationEmail && errors?.notificationEmail) ||
                  ""}
                </div>
              </div>
              
              </div>
              
              </>
            )}
            
              </div>
              
              {/* // ✏️ EDIT MODE (inputs) */}
               {isEnableWhatsApp && ( 
              <div className="ms-Grid-row" style={{ alignItems: "center", marginBottom: 12 }}>             
                {/* WhatsApp  checkbox */}
                <div className="form-field ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl3">
                  <Checkbox
                    //label="Enable WhatsApp"
                    label={<span style={{ color: themeName === "light"? "black":"white", fontWeight: 600, fontSize: 14 }}>Enable WhatsApp</span>}
                     //checked={!!values.enableWhatsApp}
                     checked={!!showWhatsAppInput}
                     disabled={disableParentAccessToggle}
                    // checked={whatsappForced ? true : enableWhatsApp}
                    // disabled={whatsappForced || disableParentAccessToggle}
                    //checked={ (isSuperAdmin ? !!values.enableWhatsApp : (whatsappForced ? true : !!values.enableWhatsApp)) }
                    //disabled={ (isSuperAdmin ? false : (whatsappForced || disableParentAccessToggle)) }
                    onChange={(_, checked) => {
                      const isChecked = !!checked;
                      // console.log("[ContactDetails] WhatsApp checkbox clicked. checked:", checked);
                      //       if (whatsappForced) {
                      //         console.log("[ContactDetails] WhatsApp forced — ignoring click");
                      //         return;
                      //       }
                      //setFieldValue("enableWhatsApp", !!checked);
                      //setShowWhatsAppInput(!!checked);
                      setShowWhatsAppInput(isChecked);
                      setFieldValue("firmWhatsappNotify", isChecked);
                      if (!checked) setFieldValue("whatsappNumber", "");
                      const nextValues = { ...values,firmWhatsappNotify: isChecked, enableWhatsApp: !!checked, whatsappNumber: !!checked ? values.whatsappNumber : "" };
                      //setEnableWhatsApp(!!checked);

if (typeof setErrorContactState === "function") {
                   setErrorContactState(prev => ({
                    ...prev,
                    contactChannel: { ...(prev.contactChannel||{}), whatsappNumber:{ error:false, msg:"" }, error:false, msg:"" }
                   }));
                      }
                      if (props.setFieldError) props.setFieldError("whatsappNumber", undefined);
                            console.log("[ContactDetails] setFieldValue enableWhatsApp ->", !!checked);
                      if (props.validateChannels) props.validateChannels(nextValues);
                      else if (props.validateForm) props.validateForm();
                    }}
                  />
                </div>
                

                
                    {/* Visible error div under whatsapp input to guarantee user sees error */}
              {/* {!!values.enableWhatsApp && (  */}
                {!!showWhatsAppInput && (     
                  <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">              
                  <CustomPhoneInput
                  //parentClassName="form-field ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4"
                  //label="WhatsApp Number"
                  name="whatsappNumber"
                  value={values.whatsappNumber || ""}
                  onBlurCustom={() =>{
                    handleBlur({ target: { name: "whatsappNumber" } });
                    if (props.validateChannels) props.validateChannels(values);}
                  }
                  onChangeCustom={(value) => {
                    if (!value.startsWith("+")) value = "+" + value; // normalize
                    setFieldValue("whatsappNumber", value);
if (typeof setErrorContactState === "function") {
                   setErrorContactState(prev => ({
                    ...prev,
                    contactChannel: { ...(prev.contactChannel||{}), whatsappNumber:{ error:false, msg:"" }, error:false, msg:"" }
                   }));
                    }
                    if (props.setFieldError) props.setFieldError("whatsappNumber", undefined);

                    if (props.validateChannels) props.validateChannels({ ...values, whatsappNumber: value });

                  }}
                  //checkError
                  // errorState={!!(touched?.whatsappNumber && errors?.whatsappNumber)}
                  // errorMessage={errors?.whatsappNumber}
                  errorState={
                    !!(touched?.whatsappNumber && errors?.whatsappNumber) ||
                    props.errorContactState?.contactChannel?.whatsappNumber?.error
                  }
                  // errorMessage={props.errorContactState?.whatsappNumber?.msg
                  // }
      
                  />
                {/* WhatsApp error div */}
                <div style={{ width: "100%", marginTop: 6, marginBottom: 6 }}>
                  <div style={{ color: "red", fontSize: 12, fontWeight: "600" }}>
                    {props.errorContactState?.contactChannel?.whatsappNumber?.msg ||
                    (touched?.whatsappNumber && errors?.whatsappNumber) || ""}
                  </div>
                </div>
                </div>
              )}
                  </div>
               )}
                  </>
              
              {/* NEW ROW 3: Backend flags for firm users (below both rows) */}
              <div className="ms-Grid-row" style={{ alignItems: "center", marginBottom: 6 }}>
                {/* Email flag column */}
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl3">
                  <Checkbox
                    label={<span style={{ color: themeName === "light"? "black":"white", fontWeight: 600, fontSize: 14 }}>Enable Email for Firm Users</span>}
                    checked={!!values.enableEmail}
                    disabled={disableParentAccessToggle || !isEnableWhatsApp }
                    onChange={(_, checked) => {
                      setFieldValue("enableEmail", !!checked);
                      if (props.setFieldError) props.setFieldError("enableEmail", undefined);
                      if (props.validateChannels) props.validateChannels({ ...values, enableEmail: !!checked });
                    }}
                  />
                </div>
                </div>

                {/* WhatsApp flag column */}
              {isEnableWhatsApp && (
                <div className="ms-Grid-row" style={{ alignItems: "center", marginBottom: 12 }}>             
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl5">
                  <Checkbox
                    label={<span style={{ color: themeName === "light"? "black":"white", fontWeight: 600, fontSize: 14 }}>Enable WhatsApp for Firm Users</span>}
                    checked={!!values.enableWhatsApp}
                    disabled={disableParentAccessToggle }
                    onChange={(_, checked) => {
                      setFieldValue("enableWhatsApp", !!checked);
                      if (props.setFieldError) props.setFieldError("enableWhatsApp", undefined);
                      if (props.validateChannels) props.validateChannels({ ...values, enableWhatsApp: !!checked });
                    }}
                  />
                </div>
                </div>
              )}
              </>
              )}

              {/* Minimal account */}
              {values?.isMinimalAccount === 1 && (props.action === ACTIONS.ADD || props.action === ACTIONS.EDIT)  && (
                <>
                  {/* Case 1: Master OFF → Only Email mandatory, WhatsApp hidden */}
                  {!masterOn && (
                    <>
                    <div className="ms-Grid-row" style={{ alignItems: "center", marginBottom: 12 }}>
                      <div className="form-field ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl3">
                        <Checkbox
                          //checked={true}
                          checked={ values.enableEmail}
                          //disabled={true} // forced mandatory
                          label={<span style={{color: themeName === "light"? "black":"white", fontWeight: 600, fontSize: 14 }}>Enable Email                        
                          {/* <span aria-hidden="true" style={{ color: "#ff4d4f", fontWeight: 700 }}>*</span> */}
                          </span>}
                          onChange={(_, checked) => {

                      const newVal = !!checked;
                      setEnableEmail(newVal);
                      setFieldValue("enableEmail", newVal);

                      // if turning off, clear email value
                      if (!checked) {
                        setFieldValue("notificationEmail", "");
                      }

                      // clear errors and call validators
             //if (props.setErrorContactState) {

  if (typeof props.setErrorContactState === "function") {
                        props.setErrorContactState(prev => ({
                          ...prev,
                          contactChannel: { ...(prev.contactChannel||{}), notificationEmail: { error:false, msg:"" }, error:false, msg:"" }
                        }));
                      }
                      if (props.setFieldError) props.setFieldError("notificationEmail", undefined);
                      if (props.validateChannels) props.validateChannels({ ...values, enableEmail: !!checked });
                      else if (props.validateForm) props.validateForm();
                    }}
                    styles={{root: {marginRight: "30px"}
                  }}
                        />
                      </div>

                      <TextField
                        className="form-field ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4"
                        //label="Notification Email"
                        placeholder="Notification Email"
                        value={values.notificationEmail || ""}
                        onChange={(_, val) => setFieldValue("notificationEmail", val)}
                        onBlur={(e) => { handleBlur(e); if (props.validateChannels) props.validateChannels(values); }}
                        errorMessage={
                          props.errorContactState?.contactChannel?.notificationEmail?.msg ||
                          (touched?.notificationEmail && errors?.notificationEmail) ||
                          undefined
                        }
                        styles={{ fieldGroup: { maxWidth: "250px" } }}
                      />
                      </div>
                    </>
                  )}

                  {/* Case: master ON => subflags decide */}
                  {masterOn && (
                    <>
                      {canEmail && (
                  // <div
                  //   className="email-row"
                  //   style={{
                  //     display: "flex",
                  //     alignItems: "center",
                  //     gap: "12px",
                  //     flexWrap: "wrap",
                  //     marginBottom: 12,
                  //   }}
                  // > 
              <div className="ms-Grid-row" style={{ alignItems: "center", marginBottom: 12 }}>
                <div className="form-field ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl3">
                  <Checkbox
                    label={<span style={{ color: themeName === "light"? "black":"white", fontWeight: 600, fontSize: 14 }}>Enable Email</span>}
                    checked={emailForced ? true : !!values.enableEmail}
                    //checked={ emailForced ? true : (masterOn && canEmail && canWhatsapp ? true : enableEmail) }
                    
                    //disabled={emailForced}
                    onChange={(_, checked) => {
                        console.log("[ContactDetails] Minimal Email checkbox clicked. checked:", checked);
                        if (emailForced) { console.log("[Click] email forced; ignoring."); return; }

                      const newVal = !!checked;
                      setEnableEmail(newVal);
                      setFieldValue("enableEmail", newVal);

                      // if turning off, clear email value
                      if (!checked) {
                        setFieldValue("notificationEmail", "");
                      }

                      // clear errors and call validators
if (typeof props.setErrorContactState === "function") {
                        props.setErrorContactState(prev => ({
                          ...prev,
                          contactChannel: { ...(prev.contactChannel||{}), notificationEmail: { error:false, msg:"" }, error:false, msg:"" }
                        }));
                      }
                      if (props.setFieldError) props.setFieldError("notificationEmail", undefined);
                      if (props.validateChannels) props.validateChannels({ ...values, enableEmail: !!checked });
                      else if (props.validateForm) props.validateForm();
                    }}
                    styles={{root: {marginRight: "30px"}
                  }}
                      />
                      </div>
                    {/* Inputs if toggled on or forced */}
                  {(emailForced || !!values.enableEmail) && (
                    <>
                  <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                    <TextField
                      //label="Notification Email"
                      placeholder="Notification Email"
                      value={values.notificationEmail || ""}
                      onChange={(_, val) => setFieldValue("notificationEmail", val)}
                    />
                    <div style={{ width: "100%", marginBottom: 6 }}>
                      <div style={{ color: "red", fontSize: 12 }}>
                          {props.errorContactState?.contactChannel?.notificationEmail?.msg ||
                          (touched?.notificationEmail && errors?.notificationEmail) ||
                          ""}
                      </div>
                  </div>
                  </div>
                  </>
                  )}
                  </div>
                  )}

                  {canWhatsapp && (
                // <div
                //         className="whatsapp-row"
                //         style={{
                //           display: "flex",
                //           alignItems: "center",
                //           gap: "12px",
                //           flexWrap: "wrap",
                //           marginBottom: 12,
                //         }}
                //       >          
                <div className="ms-Grid-row" style={{ alignItems: "center", marginBottom: 12 }}>
                  <div className="form-field ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl3">
                      <Checkbox
                        //label="Enable WhatsApp"
                        label={<span style={{ color: themeName === "light"? "black":"white", fontWeight: 600, fontSize: 14 }}>Enable WhatsApp</span>}
                        //checked={whatsappForced ? true : enableWhatsApp}
                        checked={whatsappForced ? true : !!values.enableWhatsApp}
                        //disabled={whatsappForced}
                        onChange={(_, checked) => {
                          console.log("[ContactDetails] Minimal WhatsApp checkbox clicked. checked:", checked);
                            if (whatsappForced) return;

                          const newVal = !!checked;
                          setEnableWhatsApp(newVal);
                          setFieldValue("enableWhatsApp", newVal);

                          if (!checked) {
                            setFieldValue("whatsappNumber", "");
                          }

if (typeof setErrorContactState === "function") {
                   setErrorContactState(prev => ({
                    ...prev,
                    contactChannel: { ...(prev.contactChannel||{}), whatsappNumber:{ error:false, msg:"" }, error:false, msg:"" }
                   }));
                          }
                          if (props.setFieldError) props.setFieldError("whatsappNumber", undefined);
                          if (props.validateChannels) props.validateChannels({ ...values, enableWhatsApp: !!checked });
                          else if (props.validateForm) props.validateForm();
                        }}
                      />
                      </div>
                    {(whatsappForced || !!values.enableWhatsApp) && (
                    // <TextField
                    //   //label="WhatsApp Number"
                    //   placeholder="WhatsApp Number"
                    //   value={values.whatsappNumber || ""}
                    //   onChange={(_, val) => setFieldValue("whatsappNumber", val)}
                    // />
                    <>
                  <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                    <CustomPhoneInput
                      //parentClassName="form-field ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4"
                      name="whatsappNumber"
                      value={values.whatsappNumber || ""}
                      onBlurCustom={() => {
                        handleBlur({ target: { name: "whatsappNumber" } });
                        if (props.validateChannels) props.validateChannels(values);
                      }}
                      onChangeCustom={(value) => {
                        if (!value.startsWith("+")) value = "+" + value; // normalize
                        setFieldValue("whatsappNumber", value);
if (typeof setErrorContactState === "function") {
                   setErrorContactState(prev => ({
                    ...prev,
                    contactChannel: { ...(prev.contactChannel||{}), whatsappNumber:{ error:false, msg:"" }, error:false, msg:"" }
                   }));
                        }
                        if (props.setFieldError) props.setFieldError("whatsappNumber", undefined);
                        if (props.validateChannels) props.validateChannels({ ...values, whatsappNumber: value });
                      }}
                      errorState={
                        !!(touched?.whatsappNumber && errors?.whatsappNumber) ||
                        props.errorContactState?.contactChannel?.whatsappNumber?.error
                      }
                      // errorMessage={
                      //   errors?.whatsappNumber ||
                      //   props.errorContactState?.contactChannel?.whatsappNumber?.msg ||
                      //   (touched?.whatsappNumber && errors?.whatsappNumber) ||""
                      // }
                    />
                    <div style={{ width: "100%", marginBottom: 6 }}>
                      <div style={{ color: "red", fontSize: 12 }}>
                        {props.errorContactState?.contactChannel?.whatsappNumber?.msg ||
                        (touched?.whatsappNumber && errors?.whatsappNumber) || ""}
                      </div>
                    </div>
                    </div>
                  </>
                  )}
                  </div>
                  )}

                          
                          
                  </>
                )}
              </>
                  )}
                  {props.errorContactState?.contactChannel?.error &&
                    !props.errorContactState?.contactChannel?.notificationEmail?.error &&
                    !props.errorContactState?.contactChannel?.whatsappNumber?.error && (
                      <div style={{ color: "red", marginTop: 6 }}>
                        {props.errorContactState.contactChannel.msg}
                      </div>
                  )}
                  </>
                )}
              </div>
          <ContactDetailsRow
              id="sectionA"
              headerName={t("string-literals.first-contact-details")}
              name="contact1"
              values={props.values.contact1}
              handleBlur={props.handleBlur}
              handleChange={props.handleChange}
              // errors={props.errors}
              // touched={props.touched}
              errorState={props.errorContactState?.contact1}
              checkError={props.errorContactState?.errorState}
              state={props.state}
              action = {props.action === ACTIONS.EDIT && props.roles[0] === USERTYPES.FIRMADMIN && !props.ownFirm ? ACTIONS.VIEW : props.action}
              editConfigurationSetting={props.editConfigurationSetting}

          />
          {((props.action === ACTIONS.ADD || props.action === ACTIONS.EDIT && !props.editConfigurationSetting) || (props.action === ACTIONS.VIEW && props.values.contact2.name)) &&
           <ContactDetailsRow
              id="sectionB"
              headerName={t("string-literals.second-contact-details")}
              name="contact2"
              values={props.values.contact2}
              handleBlur={props.handleBlur}
              handleChange={props.handleChange}
              errorState={props.errorContactState?.contact2}
              checkError={props.errorContactState?.errorState}
              state={props.state}
              action = {props.action === ACTIONS.EDIT && props.roles[0] === USERTYPES.FIRMADMIN && !props.ownFirm ? ACTIONS.VIEW : props.action}
          />
          }
          {((props.action === ACTIONS.ADD || props.action === ACTIONS.EDIT && !props.editConfigurationSetting) || (props.action === ACTIONS.VIEW && props.values.contact3.name)) &&
          <ContactDetailsRow
              id="sectionC"
              headerName={t("string-literals.third-contact-details")}
              name="contact3"
              values={props.values.contact3}
              handleBlur={props.handleBlur}
              handleChange={props.handleChange}
              errorState={props.errorContactState?.contact3}
              checkError={props.errorContactState?.errorState}
              state={props.state}
              action = {props.action === ACTIONS.EDIT && props.roles[0] === USERTYPES.FIRMADMIN && !props.ownFirm ? ACTIONS.VIEW : props.action}
          />
          }
        </div>
      </>
    )
};

export default ContactDetailsSection;